import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=f8ce6356&scoped=true"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"
import style0 from "./LoadingButton.vue?vue&type=style&index=0&id=f8ce6356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ce6356",
  null
  
)

export default component.exports